import {ButtonGroup} from '../ButtonGroup';

import type {ButtonGroupItemDef} from '../ButtonGroup';
import type {FC} from 'react';

export type ListView = 'table' | 'card';

export interface ListViewPickerProps {
  value: ListView;
  onChange: (view: ListView) => void;
  tableLabel: string;
  cardLabel: string;
  className?: string;
}

export const ListViewPicker: FC<ListViewPickerProps> = ({
  value,
  onChange,
  tableLabel,
  cardLabel,
  className
}) => {
  const items: ButtonGroupItemDef[] = [
    {value: 'table', icon: 'table', ariaLabel: tableLabel},
    {value: 'card', icon: 'grid', ariaLabel: cardLabel}
  ];

  return (
    <div data-slot="list-view-picker">
      <ButtonGroup
        items={items}
        value={value}
        onChange={(v: string) => onChange(v as ListView)}
        className={className}
      />
    </div>
  );
};
